export const ef_data = [
  { risk: 2.03, return: 2.22 },
  { risk: 3.53, return: 2.67 },
  { risk: 6.48, return: 3.57 },
  { risk: 9.01, return: 4.34 },
  { risk: 12.5, return: 5.41 },
  { risk: 16.0, return: 6.47 },
  { risk: 21.02, return: 7.97 },
  { risk: 25.03, return: 9.1 },
] as const;
